import clsx from "clsx";
import { SparklesIcon } from "@heroicons/react/24/solid";

export function LabelLLM() {
    return (
        <div
            className={clsx(
                "w-fit bg-slate-700 px-2 py-1",
                "flex items-center gap-2 rounded-full",
            )}
        >
            <span className="ui-label text-white">AI-Generated</span>
            <SparklesIcon className="size-4" />
        </div>
    );
}
